import { HttpErrorResponse } from '@angular/common/http';
import {
	Component,
	OnInit,
	OnDestroy,
	ViewChild,
	TemplateRef,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';

import { finalize, Subject, takeUntil } from 'rxjs';

import { OrganizationDto } from '../../../../modules/organizations/dtos/organization';
import { OrganizationsService } from '../../../../modules/organizations/organizations.service';
import { SnackBarService } from '../../../../shared/components/snack-bar/snack-bar.service';

@Component({
	selector: 'app-digital-hospital',
	styleUrls: ['./digital-hospital.component.scss'],
	templateUrl: './digital-hospital.component.html',
})
export class DigitalHospitalComponent implements OnInit, OnDestroy {
	@ViewChild('confirmationDialog') confirmationDialog!: TemplateRef<any>;
	hasDigitalHospital: boolean = false;
	isLoading = false;
	org: OrganizationDto | undefined = undefined;
	organizationId: string = '';
	private readonly unsubscribe$: Subject<void> = new Subject<void>();

	constructor(
		private readonly activatedRoute: ActivatedRoute,

		private readonly dialog: MatDialog,
		private readonly organizationsService: OrganizationsService,
		private readonly snackBarService: SnackBarService,
	) {}

	fetchOrganizationDetails(): void {
		this.isLoading = true;
		this.organizationsService
			.getById(this.organizationId)
			.pipe(
				takeUntil(this.unsubscribe$),
				finalize(() => (this.isLoading = false)),
			)
			.subscribe({
				error: (err: HttpErrorResponse) => {
					this.snackBarService.showSnack(
						err.error?.message || 'Erro ao buscar detalhes da organização.',
						'error',
					);
				},
				next: (org: OrganizationDto) => {
					this.org = org;
					this.hasDigitalHospital = org.hasDigitalHospital || false;
					this.isLoading = false;
				},
			});
	}

	getButtonText(): string {
		return this.hasDigitalHospital
			? 'Desativar Hospital Digital'
			: 'Ativar Hospital Dígital';
	}

	ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}

	ngOnInit(): void {
		this.activatedRoute.params
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe((params) => {
				this.organizationId = params.id;
				if (this.organizationId) {
					this.fetchOrganizationDetails();
				}
			});
	}

	toogleDigitalHospital(): void {
		if (this.hasDigitalHospital) {
			const dialogRef = this.dialog.open(this.confirmationDialog, {
				autoFocus: false,
				width: '550px',
			});

			dialogRef.afterClosed().subscribe((result) => {
				if (result) {
					this.executeToggle();
				}
			});
		} else {
			this.executeToggle();
		}
	}

	private executeToggle(): void {
		if (!this.organizationId) {
			this.snackBarService.showSnack(
				'ID da organização não encontrado.',
				'error',
			);

			return;
		}

		this.isLoading = true;
		this.organizationsService
			.toogleDigitalHospital(
				this.organizationId,
				this.org,
				this.hasDigitalHospital,
			)
			.pipe(
				takeUntil(this.unsubscribe$),
				finalize(() => (this.isLoading = false)),
			)
			.subscribe({
				error: (err: HttpErrorResponse) => {
					this.snackBarService.showSnack(
						err.error?.message || 'Erro ao atualizar a organização.',
						'error',
					);
				},
				next: (response) => {
					this.hasDigitalHospital = !this.hasDigitalHospital;
					this.snackBarService.showSnack(
						response.message || 'Organização atualizada com sucesso.',
						'success',
					);
				},
			});
	}
}
